module.exports = {
    "breadcrumbs": `Drobtine`
};


//# sourceMappingURL=sl-SI.main.js.map
